<template>
  <repair-mobile v-if="isMobile" :tableData="tableData" :columns="columns">
  </repair-mobile>
  <div class="repair" v-else>
    <!-- <div class="select-machine df both-side">
      <a-space>
        <template v-for="(item, index) in processStatus" :key="index">
          <div>
            <a-tag color="#87d068" v-if="item.repairProcess === -1"
              >已完成 {{ item.count }}</a-tag
            >
            <a-tag color="pink" v-if="item.repairProcess === 0"
              >仓管 {{ item.count }}</a-tag
            >
            <a-tag color="red" v-if="item.repairProcess === 1"
              >质检 {{ item.count }}</a-tag
            >
            <a-tag color="orange" v-if="item.repairProcess === 2"
              >工艺 {{ item.count }}</a-tag
            >
            <a-tag color="green" v-if="item.repairProcess === 3"
              >生产 {{ item.count }}</a-tag
            >
            <a-tag color="cyan" v-if="item.repairProcess === 4"
              >闭环 {{ item.count }}</a-tag
            >
            <a-tag color="purple" v-if="item.repairProcess === 5"
              >审核 {{ item.count }}</a-tag
            >
          </div>
        </template>
      </a-space>

      <a-space>
        <a-tag> {{ nickName }} </a-tag>
        <a-radio-group
          v-if="isAdmin"
          v-model:value="page"
          size="small"
          @change="handlePageTypeChange"
        >
          <a-radio-button value="repair">返修</a-radio-button>
          <a-radio-button value="authority">权限</a-radio-button>
        </a-radio-group>

        <a-button size="small" @click="logout" type="danger">登出</a-button>
      </a-space>
    </div> -->

    <div ref="scrollBox">
      <div class="repair-table space-box" v-if="page === 'repair'">
        <div class="toolbar df both-side">
          <a-space>
            <template v-for="(item, index) in processStatus" :key="index">
              <div>
                <a-tag color="#87d068" v-if="item.repairProcess === -1"
                  >已完成 {{ item.count }}</a-tag
                >
                <a-tag color="pink" v-if="item.repairProcess === 0"
                  >仓管 {{ item.count }}</a-tag
                >
                <a-tag color="red" v-if="item.repairProcess === 1"
                  >质检 {{ item.count }}</a-tag
                >
                <a-tag color="orange" v-if="item.repairProcess === 2"
                  >工艺 {{ item.count }}</a-tag
                >
                <a-tag color="green" v-if="item.repairProcess === 3"
                  >生产 {{ item.count }}</a-tag
                >
                <a-tag color="cyan" v-if="item.repairProcess === 4"
                  >闭环 {{ item.count }}</a-tag
                >
                <a-tag color="purple" v-if="item.repairProcess === 5"
                  >审核 {{ item.count }}</a-tag
                >
              </div>
            </template>
          </a-space>

          <!-- <a href="//wpa.qq.com/msgrd?v=3&uin=1691786484&site=qq&menu=yes">
            有事找经颖
          </a> -->

          <a-space>
            <a-select
              ref="select"
              v-model:value="requestPayload.repairProcessType"
              style="width: 120px"
              allowClear
              @change="handleSearch"
              placeholder="返修进度"
            >
              <a-select-option :value="0">仓管</a-select-option>
              <a-select-option :value="1">质检</a-select-option>
              <a-select-option :value="2">工艺</a-select-option>
              <a-select-option :value="3">生产</a-select-option>
              <a-select-option :value="4">闭环</a-select-option>
              <a-select-option :value="5">审核</a-select-option>
              <a-select-option :value="-1">已完成</a-select-option>
            </a-select>
            <!-- <a-select
              ref="select"
              v-model:value="requestPayload.serialType"
              style="width: 120px"
              allowClear
              @change="updateMachineType"
              placeholder="类型"
            >
              <a-select-option value="天鸽">天鸽</a-select-option>
              <a-select-option value="天鹅">天鹅</a-select-option>
            </a-select> -->
            <a-cascader
              v-model:value="selectSerial"
              :options="options"
              @change="handleSerialChange"
              placeholder="选择设备类型"
              style="width: 140px"
            />
            <a-input
              v-model:value="requestPayload.serial"
              placeholder="请输入机身号"
              enter-button
              @change="handleSearch"
              style="width: 180px"
            />
            <a-button type="primary" @click="addRepair">新增返修设备</a-button>
          </a-space>
        </div>

        <div class="table-space">
          <a-table
            bordered
            :dataSource="tableData"
            :columns="columns"
            rowKey="id"
            :pagination="false"
            :scroll="{ x: 'calc( 100vw - 280px )', y: 'calc( 100vh - 320px )' }"
          >
            <template #afterSaleProblemDescription="{ record }">
              <div
                v-for="(item, index) in JSON.parse(
                  record.afterSaleProblemDescription
                )"
                :key="index"
              >
                {{ index + 1 }}：{{ item.value }}
              </div>
            </template>

            <template #picture="{ record }">
              <a-image-preview-group v-if="record.picture">
                <a-image
                  v-for="(item, index) in JSON.parse(record.picture)"
                  :width="50"
                  :key="index"
                  :src="item"
                />
              </a-image-preview-group>
            </template>

            <template #video="{ record }">
              <a-image-preview-group>
                <video
                  v-for="(item, index) in JSON.parse(record.video)"
                  :width="100"
                  :height="70"
                  :key="index"
                  :src="item"
                  controls
                />
              </a-image-preview-group>
            </template>

            <template #repairProcess="{ record }">
              <a-tag color="#87d068" v-if="record.repairProcess === -1"
                >已完成
              </a-tag>
              <a-tag color="pink" v-if="record.repairProcess === 0">仓管</a-tag>
              <a-tag color="red" v-if="record.repairProcess === 1">质检</a-tag>
              <a-tag color="orange" v-if="record.repairProcess === 2"
                >工艺</a-tag
              >
              <a-tag color="green" v-if="record.repairProcess === 3"
                >生产</a-tag
              >
              <a-tag color="cyan" v-if="record.repairProcess === 4">闭环</a-tag>
              <a-tag color="purple" v-if="record.repairProcess === 5"
                >审核</a-tag
              >
            </template>
            <template #action="{ record }">
              <a-space>
                <a-button
                  @click="handleStartRepairProcess(record)"
                  size="small"
                  type="primary"
                  v-if="record.repairProcess === null"
                >
                  开启流程
                </a-button>
                <a-button @click="handleEditRepair(record)" size="small"
                  >编辑</a-button
                >
                <a-button
                  @click="lookdetail(record)"
                  type="parimary"
                  size="small"
                  v-if="record.repairProcess !== null"
                  >查看</a-button
                >
                <a-button
                  size="small"
                  type="danger"
                  @click="handleDelete(record)"
                >
                  删除
                </a-button>
              </a-space>
            </template>
          </a-table>
        </div>

        <div class="pagination df both-side">
          <div></div>
          <a-pagination
            v-model:current="requestPayload.pageNum"
            v-model:pageSize="requestPayload.lineNum"
            :total="requestPayload.total"
            :show-total="(total) => `共 ${total} 条`"
            @change="handlePageChange"
            @showSizeChange="handleSizeChange"
            size="small"
          />
        </div>
      </div>
      <div class="repair-table" v-else>
        <div class="toolbar df both-side">
          <a-button @click="handleAddAuthority">新增账户</a-button>
        </div>

        <div class="table-space">
          <a-table
            bordered
            :dataSource="authorityTableData"
            :columns="authorityColumns"
            rowKey="id"
            :pagination="false"
          >
            <template #type="{ record }">
              <a-tag color="#87d068" v-if="record.type === 0"
                >超级管理员
              </a-tag>
              <a-tag color="#87d068" v-if="record.type === 1">售后 </a-tag>
              <a-tag color="orange" v-if="record.type === 2">仓管</a-tag>
              <a-tag color="green" v-if="record.type === 3">质检</a-tag>
              <a-tag color="cyan" v-if="record.type === 4">工艺</a-tag>
              <a-tag color="purple" v-if="record.type === 5">生产</a-tag>
            </template>
            <template #action="{ record }">
              <a-space>
                <a-button
                  @click="handleChangePassword(record)"
                  size="small"
                  type="primary"
                >
                  修改密码
                </a-button>

                <a-button
                  @click="handleDeleteUser(record)"
                  size="small"
                  type="danger"
                  >删除</a-button
                >
              </a-space>
            </template>
          </a-table>
        </div>

        <div class="pagination">
          <div></div>
          <a-pagination
            v-model:current="requestPayload.pageNum"
            v-model:pageSize="requestPayload.lineNum"
            :total="requestPayload.total"
            :show-total="(total) => `共 ${total} 条`"
            @change="handlePageChange"
            @showSizeChange="handleSizeChange"
            size="small"
          />
        </div>
      </div>
    </div>
  </div>

  <repair-form ref="repair" @updateTable="updateTable"></repair-form>

  <user-form ref="userform" @updateTable="getAuthorityData"></user-form>

  <update-password-vue ref="updatepassword"> </update-password-vue>
</template>

<script>
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  watch,
} from "vue";
import {
  getRepairEquipmentList,
  deleteRepairEquipment,
  getRepairStatistics,
  getUserList,
  startRepairProcess,
  deleteUser,
} from "@/request/view/repair";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { showModal } from "@/views/repairprogress/serve/modal";
import { debounce, Toast } from "@/utils/index";
import {
  repairList,
  handleUpdatePage,
  handleUpdateRequestPayload,
  getRepairListData,
} from "./serve/search";
import repairForm from "./components/repairForm.vue";
import userForm from "./components/userForm.vue";
import repairMobile from "./mobile.vue";
import updatePasswordVue from "./components/updatePassword.vue";

export default defineComponent({
  components: { repairForm, userForm, repairMobile, updatePasswordVue },
  setup() {
    const repair = ref();
    const updatepassword = ref();
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const isMobile = computed(() => store.state.isMonile);

    const requestPayload = reactive({
      serial: null,
      lineNum: 10,
      pageNum: 1,
      serialType: null,
      userId: store.getters.user.id,
      total: 0,
      repairProcessType: null,
    });
    const selectSerial = ref([]);
    // 设备配置项
    const options = [
      {
        value: "天鸽",
        label: "天鸽",
        children: [
          {
            value: "300",
            label: "300",
          },
          {
            value: "300S",
            label: "300S",
          },
        ],
      },
      {
        value: "天鹅",
        label: "天鹅",
        children: [
          {
            value: "600",
            label: "600",
          },
          {
            value: "600P",
            label: "600P",
          },
        ],
      },
      {
        value: "筛查箱",
        label: "筛查箱",
        children: [
          {
            value: "310",
            label: "310",
          },
          {
            value: "310S",
            label: "310S",
          },
        ],
      },
    ];

    // const nickName = computed(() => {
    //   if (store.getters.user) {
    //     return store.getters.user.nickName;
    //   }
    //   return "";
    // });
    // const isAdmin = computed(() => {
    //   if (store.getters.user) {
    //     return store.getters.user.pid === 0 || store.getters.user.type === 0;
    //   }
    //   return false;
    // });

    // const isAfterSales = computed(() => {
    //   if (store.getters.user) {
    //     return store.getters.user.type === 1 || store.getters.user.type === 0;
    //   }
    //   return false;
    // });

    const processStatus = reactive([
      {
        count: 0,
        repairProcess: 0,
      },
      {
        count: 0,
        repairProcess: 1,
      },
      {
        count: 0,
        repairProcess: 2,
      },
      {
        count: 0,
        repairProcess: 3,
      },
      {
        count: 0,
        repairProcess: 4,
      },
      {
        count: 0,
        repairProcess: 5,
      },
      {
        count: 0,
        repairProcess: -1,
      },
    ]);

    const getStatistics = () => {
      getRepairStatistics().then((res) => {
        if (res.code === 200 && res.message === "成功") {
          processStatus.forEach((item) => {
            const { repairProcess } = item;

            const statistics = res.data.find(
              (find) => find.repairProcess === repairProcess
            );

            if (statistics) item.count = statistics.count;
          });
        }
      });
    };

    const tableData = reactive([]);

    const columns = reactive([
      { title: "年度", dataIndex: "year", width: 80, align: "center" },
      {
        title: "创建时间",
        dataIndex: "createTime",
        width: 175,
        align: "center",
      },
      { title: "机身号", dataIndex: "serial", width: 175, align: "center" },
      {
        title: "返厂时间",
        dataIndex: "returnDate",
        width: 120,
        align: "center",
      },
      {
        title: "返厂地址",
        dataIndex: "returnAddress",
        width: 120,
        align: "center",
      },
      {
        title: "返修进度",
        dataIndex: "repairProcess",
        slots: { customRender: "repairProcess" },
        width: 100,
        align: "center",
      },
      {
        title: "售后问题描述",
        dataIndex: "afterSaleProblemDescription",
        slots: { customRender: "afterSaleProblemDescription" },
        width: 240,
      },
      {
        title: "售后问题图片",
        dataIndex: "picture",
        slots: { customRender: "picture" },
        width: 140,
      },
      {
        title: "售后问题视频",
        dataIndex: "video",
        slots: { customRender: "video" },
        width: 140,
      },
      {
        title: "对接人",
        dataIndex: "contactPerson",
        width: 100,
        align: "center",
      },
      { title: "新编号", dataIndex: "newCode", width: 160, align: "center" },
      {
        title: "替代仪器",
        dataIndex: "replaceSerial",
        width: 160,
        align: "center",
      },
      { title: "返修客户信息", dataIndex: "repairCustomerInfo", width: 252 },
      {
        title: "操作",
        dataIndex: "action",
        slots: { customRender: "action" },
        width: 220,
        align: "center",
        fixed: "right",
      },
    ]);

    const checkViewCustomInfo = () => {
      if (!route.meta["/customerinformationviewing"]) {
        const customInfoIndex = columns.findIndex(
          (item) => item.title === "返修客户信息"
        );
        console.log(customInfoIndex);
        if (customInfoIndex !== -1) {
          columns.splice(customInfoIndex, 1);
        }
        return false;
      }
      return true;
    };

    const getRepairData = () => {
      getRepairEquipmentList({
        serial: requestPayload.serial,
        lineNum: requestPayload.lineNum,
        pageNum: requestPayload.pageNum,
        serialType: requestPayload.serialType,
        repairProcessType: requestPayload.repairProcessType,
        userId: requestPayload.userId,
      })
        .then((res) => {
          if (res.code === 200 && res.message === "成功") {
            tableData.length = 0;
            tableData.push(...res.data.records);
            requestPayload.total = res.data.total;
          }
          console.log(res);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const handleSearch = debounce(() => {
      requestPayload.pageNum = 1;
      getRepairData();
    }, 150);

    const updateMachineType = (type) => {
      requestPayload.pageNum = 1;
      getRepairData();
    };

    const handlePageChange = (page, pageSize) => {
      requestPayload.pageNum = page;
      getRepairData();
    };

    const handleSizeChange = (current, size) => {
      requestPayload.lineNum = size;
      getRepairData();
    };

    // 编辑
    const handleEditRepair = (reocrd) => {
      if (!route.meta["/updaterepairinformation"]) {
        return Toast("warning", "无权限", 3);
      }
      const customInfoAuthority = checkViewCustomInfo();
      repair.value.editForm(reocrd, customInfoAuthority);
    };

    const updateTable = (isAddRepair) => {
      if (isAddRepair) {
        requestPayload.pageNum = 1;
        handleUpdatePage(1);
      }
      if (isMobile.value) {
        getRepairListData();
      } else {
        getRepairData();
        getStatistics();
      }
    };

    const addRepair = () => {
      if (!route.meta["/addrepairinformation"]) {
        return Toast("warning", "无权限", 3);
      }
      const customInfoAuthority = checkViewCustomInfo();
      repair.value.addRepair(customInfoAuthority);
    };

    const lookdetail = (e) => {
      router.push({
        path: "/repairprogress",
        query: {
          machineId: e.id,
          type: e.serialType,
          semiFinishedProducts: e.semiFinishedProducts,
          componentsAndParts: e.componentsAndParts,
          attribute: e.attribute,
          returnDate: e.returnDate,
          replaceSerial: e.replaceSerial,
          newCode: e.newCode,
          repairProcess: e.repairProcess,
          principal: e.principal,
          completeDate: e.completeDate,
          auditTime: e.auditTime,
          username: e.username,
          userId: e.userId,
          afterSaleProblemDescription: e.afterSaleProblemDescription,
          video: e.video,
          picture: e.picture,
          contactPerson: e.contactPerson,
          serial: e.serial,
          meta: encodeURI(JSON.stringify(route.meta)),
        },
      });
    };

    const handleDelete = (e) => {
      if (!route.meta["/deleterepairinformation"]) {
        return Toast("warning", "无权限", 3);
      }
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteRepairEquipment([e.id])
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              getRepairData();
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const handleStartRepairProcess = (e) => {
      if (!route.meta["/startrepairprocess"]) {
        return Toast("warning", "无权限", 3);
      }
      showModal({
        title: "提示",
        toastText: "确认开启返修流程？",
        success: () => {
          startRepairProcess({ id: e.id })
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              getRepairData();
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const page = ref("repair");

    const authorityColumns = [
      { title: "账号", dataIndex: "username" },
      { title: "密码", dataIndex: "password" },
      { title: "昵称", dataIndex: "nickName" },
      {
        title: "类型",
        dataIndex: "type",
        slots: { customRender: "type" },
      },
      {
        title: "操作",
        dataIndex: "action",
        slots: { customRender: "action" },
      },
    ];

    const authorityTableData = reactive([]);

    const getAuthorityData = () => {
      getUserList({
        id: store.getters.user.id,
      }).then((res) => {
        authorityTableData.length = 0;
        if (res.code === 200 && res.message === "成功") {
          authorityTableData.push(...res.data);
          requestPayload.total = res.data.length;
        }
      });
    };

    const handleSerialChange = (e) => {
      if (selectSerial.value.length === 2) {
        const [machine, type] = e;
        requestPayload.serialType = `${machine}${type}`;
      } else {
        requestPayload.serialType = null;
      }
      getRepairData();
    };

    const userform = ref();

    const handleAddAuthority = () => {
      userform.value.showModal();
    };

    const scrollBox = ref();
    const tableSroll = reactive({
      x: null,
      y: null,
    });

    const getTableScroll = () => {
      nextTick(() => {
        if (scrollBox.value) {
          const domInfo = scrollBox.value.getBoundingClientRect();
          tableSroll.x = domInfo.right - domInfo.left - 80;
          tableSroll.y = domInfo.height - 240;
        }
      });
    };

    window.addEventListener("resize", getTableScroll);

    const handleDeleteUser = (e) => {
      showModal({
        title: "提示",
        toastText: "确认删除？",
        success: () => {
          deleteUser([e.id])
            .then((res) => {
              Toast(res.code === 200 ? "success" : "warning", res.message, 3);
              getAuthorityData();
            })
            .catch((err) => {
              console.log(err);
            });
        },
      });
    };

    const logout = () => {
      route.query.logout = true;
      // localStorage.removeItem("qc_userInfo");
      // localStorage.removeItem("qc_user_account_status");
      // localStorage.removeItem("qc_user_account");
      store.commit("SET_USER_INFO", {});
      const long = window.history.length - 1;
      router.go(-long);
      window.location.reload();
    };

    const handlePageTypeChange = () => {
      if (page.value === "repair") {
        getRepairData();
        getStatistics();
      } else {
        getAuthorityData();
      }
    };

    // 修改密码
    const handleChangePassword = (record) => {
      updatepassword.value.showModal(record);
    };

    onMounted(() => {
      getTableScroll();
    });

    watch(
      () => route,
      (val) => {
        if (val.path === "/repairequipment") {
          if (isMobile.value) {
            getRepairListData();
          } else {
            getRepairData();
            getStatistics();
          }
          checkViewCustomInfo();
        }
      },
      {
        immediate: true,
        deep: true,
      }
    );

    return {
      handleSearch,
      updateMachineType,
      requestPayload,
      getRepairData,
      tableData,
      columns,
      handlePageChange,
      handleSizeChange,
      handleEditRepair,
      repair,
      updateTable,
      addRepair,
      lookdetail,
      handleDelete,
      getStatistics,
      processStatus,
      page,
      handlePageTypeChange,
      authorityTableData,
      authorityColumns,
      handleAddAuthority,
      handleDeleteUser,
      userform,
      getAuthorityData,
      // isAdmin,
      logout,
      // isAfterSales,
      // nickName,
      handleStartRepairProcess,
      options,
      selectSerial,
      handleSerialChange,
      isMobile,
      handleChangePassword,
      updatepassword,
      scrollBox,
      tableSroll,
    };
  },
});
</script>

<style lang="less" scoped>
.repair {
  background: #f9f9f9;
  .select-machine {
    height: 60px;
    background: #fcfcfc;
    box-shadow: 3px 3px 8px 4px rgba(8, 26, 81, 0.04);
    padding: 0 20px;
    .machine {
      width: 200px;
      height: 60px;
      background: #fcfcfc;
      text-align: center;
      line-height: 60px;
      position: relative;
      font-size: 20px;
    }
    .active {
      color: #35b7ad;
      border-bottom: 2px solid #35b7ad;
    }
  }
  .space-box {
    padding: 0 20px;
  }
  .repair-table {
    width: 100%;
    height: calc(100vh - 120px);
    background: #ffffff;
    box-shadow: 3px 3px 8px 4px rgba(8, 26, 81, 0.04),
      0px 2px 4px -1px rgba(8, 26, 81, 0.08);
    border-radius: 10px;
    .toolbar {
      height: 68px;
      border-radius: 2px;
      padding: 20px 24px;
      border-bottom: 1px solid #d8d8d8;
    }
    .table-space {
      padding: 20px 0px 5px;
      height: calc(100vh - 240px);
    }
    .pagination {
      padding: 8px;
    }
  }
}
</style>
